import { render, staticRenderFns } from "./ManageQuizzes.vue?vue&type=template&id=75e8b840&"
import script from "./ManageQuizzes.vue?vue&type=script&lang=js&"
export * from "./ManageQuizzes.vue?vue&type=script&lang=js&"
import style0 from "./ManageQuizzes.vue?vue&type=style&index=0&id=75e8b840&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports